import styled from 'styled-components';

export const Wrapper = styled.div`
display: 100%;
height: 100vh;
background-color: var(--theme-primary);
overflow: hidden;
`